<template>
  <card :flat="flat" class="schedule-report-item-card" :class="{ 'is-editing': props.isEditing }">
    <template slot="header">
      <h5 class="h3 mb-0">{{ props.scheduleReportItem.reporter_name }}</h5>
      <div class="ml-auto">
        <span>Criado em: {{ props.scheduleReportItem.created_at | formatDate('datetime') }}</span>
        <div v-if="props.scheduleReportItem.created_at != props.scheduleReportItem.updated_at">
          Última edição em: {{ props.scheduleReportItem.updated_at | formatDate('datetime') }}
        </div>
      </div>

      <dropdown
        v-if="canEdit && props.canEdit !== false"
        class="dropdown schedule-report-item-action-btn"
        placement="bottom-end"
      >
        <span class="btn btn-sm btn-icon-only text-success">
          <i class="fas fa-ellipsis-v mt-2"></i>
        </span>
        <dropdown-menu
          class="dropdown-menu dropdown-menu-arrow show"
          slot="dropdown"
        >
          <a class="dropdown-item" href="#" @click.prevent.stop="emit('action:edit', props.scheduleReportItem)">Editar</a>
          <a class="dropdown-item text-danger" href="#" @click.prevent.stop="emit('action:delete', props.scheduleReportItem)">Excluir</a>
        </dropdown-menu>
      </dropdown>
    </template>
    <div>
      <div class="schedule-report-item-content">
        {{ props.scheduleReportItem.content }}
      </div>
      <div class="schedule-report-item-files">
        <file-list :files="props.scheduleReportItem.media" :remove="false" />
      </div>
    </div>
  </card>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";
import FileList from "@/components/FileList";
import { Dropdown, DropdownMenu } from "element-ui";

const props = defineProps({
  scheduleReportItem: {
    type: Object,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
  canEdit: {
    type: Boolean,
  },
  flat: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(["action:delete", "action:edit"]);

const currentUser = JSON.parse(localStorage.currentUser);
const canEdit = computed(() => {
  if (!currentUser) return false;
  if (!(props.scheduleReportItem && props.scheduleReportItem.reporter_id)) return false;

  return currentUser.id === props.scheduleReportItem.reporter_id;
});
</script>

<style lang="scss">
.schedule-report-item-card {
  margin-bottom: 1rem;
  width: 100%;

  &.is-editing {
    // opacity: 0.5;

    &::before {
      content: "Em edição";
      position: absolute;
      width: 100%;
      height: 100%;
      padding: 30px;
      background-color: rgba(255, 255, 255, 0.85);
      text-align: center;
      font-size: 1.5rem;
      font-weight: bold;
      z-index: 1;
      cursor: not-allowed;
    }
  }
}

.schedule-report-item-action-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>
